import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { initSentry } from './sentryClient';

initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const helmetContext = {};

root.render(
  <HelmetProvider context={helmetContext}>
    <App />
  </HelmetProvider>
);
